import { DrizzleAppSchema } from '@powersync/drizzle-driver';
import { drizzleSchema } from './drizzle/generated/index.js';

export { drizzleSchema };

/**
 * PowerSync client schema derived from Drizzle SQLite table definitions.
 * DrizzleAppSchema extends Schema from @powersync/common, so this is
 * directly assignable to any prop that accepts Schema.
 */
export const AppSchema = new DrizzleAppSchema(drizzleSchema);

/** Maps table names to their row types for typed queries. */
export type Database = (typeof AppSchema)['types'];

/** Row type for the app_config table. */
export type AppConfigRecord = Database['app_config'];
